import React from "react";
import { useHistory } from "react-router-dom";

const MobileSearch = (props) => {
  const {inputRefMobile} = props
  ////console.log(inputRefMobile);
  
  const history = useHistory()
  const search = () => {
    //console.log("Premuta Ricerca");
    var queryText = document.getElementById("queryText").value
    history.push(process.env.PUBLIC_URL + "/shop-grid-full-width?name="+queryText)
  }

  return (
    <div className="offcanvas-mobile-search-area">
      <form action="#">
        <input autofocus ref = {inputRefMobile} type="search" placeholder="Cerca ..." />
        <button autofocus type="submit" onClick={() => search()}>
          <i className="fa fa-search" />
        </button>
      </form>
    </div>
  );
};

export default MobileSearch;
